import { Col, Tabs } from "antd"
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { TabPane } from "../../../../compnents/widgets/TabBar"
import styles from '../../functionSettingTabs.module.css'
import { MedicalRecordSetting } from "./medicalRecordSettings/MedicalRecordSetting"


export const FieldSetting = (props: {
  selectedTab: any
}): ReactElement => {

  useEffect(() => {
    if (props?.selectedTab !== '11') {
      return
    }
  }, [props?.selectedTab])


  return (
    <Col className={styles.fieldSettinContainer}>
      <Tabs
         tabPosition={'top'}
        defaultActiveKey="A1"
      >
        <TabPane key='A1' tab='病历设置'>
          <MedicalRecordSetting selectedTab={'A1'}></MedicalRecordSetting>
        </TabPane>
        {/* <TabPane key='A2' tab='患者设置'>
        </TabPane> */}
      </Tabs>
    </Col>
  )
}
